import React, { FC, ReactNode } from 'react';
import Avatar, { AvatarProps } from '@material-ui/core/Avatar';
import LogImage from '~/images/icons/logo.png';
import styled from 'styled-components';
import Grid, { GridProps } from '@material-ui/core/Grid';

const RootGrid: FC<GridProps> = styled(Grid)`
  margin: auto;
  max-width: 600px;
  height: 100%;
`;

const StyledAvatar: FC<AvatarProps> = styled(Avatar)`
  width: 100%;
  height: auto;
  max-width: 250px;
`;

interface ApplicationMessageBoxProps {
  children: ReactNode;
}

const ApplicationMessageBox = ({ children }: ApplicationMessageBoxProps) => {
  return (
    <RootGrid container direction="column" justify="center" alignItems="center">
      <Grid item>
        <StyledAvatar src={LogImage} variant="rounded" />
      </Grid>
      <Grid item>{children}</Grid>
    </RootGrid>
  );
};

export default ApplicationMessageBox;
